<template>
  <div class="leftres">
    <div>
      <div class="inputtop">
        <div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
          <Commondropdownlist ref="wareselect" :key="index" :lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </div>
        <div style="display: inline-block;float: right; margin-top: 5px; margin-right: 0px;">
          <CommonBtngroup :qhide="false" :show="false" @reset="reset" @select="select"></CommonBtngroup>
        </div>
      </div>
      <div class="TableBox" style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
        <Warehousearchivestable :tableData="tableData" :total="total" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Warehousearchivestable>
      </div>
      <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK" :src="'../assets/icon/icon-errors.png'">
        <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
      </Dialog>
    </div>
  </div>
</template>
<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import Dialog from '../../../components/dialog.vue'
import Warehousearchivestable from './components/warehousearchivestable.vue'
import { WarehouseList } from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    Warehousearchivestable,
    Dialog,
    CommonBtngroup
  },
  data() {
    return {
      total: 1,
      pageindex: 1,
      pageSize: 20,
      tableData: [],
      dialogVisibles: false,
      whName: "",
      formdata: [
        {
          inputdata: '',
          title: '仓库名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '210px',
          lablewith: '70px'
        },
      ]
    }
  },
  mounted() {
    this.warehouseList()
  },
  methods: {
    // 列表
    async warehouseList() {
      let {
        data,
        code
      } = await WarehouseList({
        whName: this.whName,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (code == 0) {
        this.total = data.Count
        if (data.data) {
          this.tableData = data.data
        }
      }
    },
    select() {
      this.pageindex = 1
      this.whName = this.$refs.wareselect[0].modelvalue
      this.warehouseList()
    },
    reset() {
      this.$refs.wareselect.map((item, index) => {
        item.modelvalue = ""
      })
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      this.dialogVisibles = false
    },
    handleCurrentChange(pageindex) {
      this.pageindex = pageindex
      this.warehouseList()
    },
    handleSizeChange(paegSzie) {
      this.pageSize = paegSzie
      this.warehouseList()
    },
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 10px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
}
</style>